import React from "react";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { CheckboxGroup, ICheckboxOption } from "common/checkbox";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { useFeatureFlags } from "features/FeaturesContext";
interface ICustomListMultiSelectFieldProps {
  value: Option[] | null;
  setValue: (value: Option[] | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CustomListMultiSelectField = ({
  value = [],
  setValue,
  schema,
  labelledById,
}: ICustomListMultiSelectFieldProps) => {
  const { ff_release_13_design_system_components } = useFeatureFlags(
    "ff_release_13_design_system_components",
  );
  const options: ICheckboxOption[] =
    schema?.optionChoices?.map((optionChoice) => ({
      label: optionChoice.value,
      value: optionChoice.id,
      "data-custom-css-value": optionChoice.value, // for form custom css
    })) || [];

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = event.target.value;
    const selectedOption = schema?.optionChoices?.find(
      (option) => option.id === selectedId,
    );

    if (selectedOption) {
      const optionObject = {
        colour: selectedOption.colour,
        value: selectedOption.value,
        id: selectedOption.id,
      };

      if (event.target.checked) {
        setValue(value ? [...value, optionObject] : [optionObject]);
      } else {
        setValue(value?.filter((v) => v.id !== selectedId) || []);
      }
    }
  };
  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    option: Option,
  ) => {
    if (e.target.checked) {
      !!value ? setValue([...value, option]) : setValue([option]);
    } else {
      setValue(value?.filter((v) => v.id !== option.id) || []);
    }
  };
  return ff_release_13_design_system_components ? (
    <CheckboxGroup
      label=""
      options={options}
      onChange={handleChange}
      values={value?.map((v) => v.id) || []}
    />
  ) : (
    <FormGroup>
      {schema?.optionChoices?.map((option, idx) => (
        <FormControlLabel
          key={idx}
          control={
            <Checkbox
              aria-labelledby={labelledById}
              checked={!!value?.find((v) => v.id == option.id)}
              onChange={(e) =>
                handleOnChange(e, {
                  colour: option.colour,
                  value: option.value,
                  id: option.id,
                })
              }
            />
          }
          label={option.value}
          data-custom-css-value={option.value} // for form custom css
        />
      ))}
    </FormGroup>
  );
};
